import React from 'react'
import actions from '../../actions/SBCConfigurations'
import Component from '../common/Component'
import CreateForm, { defaultPropTypes, connectCreateForm } from '../common/CreateForm'
import LabeledTextField from '../common/LabeledTextField'
import CheckboxField from '../common/CheckboxField'
import LgcCustomerOptions from './LgcCustomerOptions'

export class SbcConfigurationCreate extends Component {
  static propTypes = defaultPropTypes

  handleChange = (attributes) => {
    if (!attributes.lgc_customer) {
      // eslint-disable-next-line no-param-reassign
      attributes.lgc_customer_options = []
    }
  }

  render() {
    return (
      <CreateForm {...this.props} handleChange={this.handleChange}>
        <LabeledTextField
          key="source_identifier"
          name="source_identifier"
          label="Source ID"
        />
        <CheckboxField
          key="lgc_customer"
          name="lgc_customer"
          label="Large Group Custom"
        />

        <LgcCustomerOptions
          key="lgc_customer_options"
          name="lgc_customer_options"
        />
      </CreateForm>
    )
  }
}

export default connectCreateForm(
  SbcConfigurationCreate,
  'SBC Configuration',
  'sbc_configurations',
  actions,
  '/configurations'
)
